import React, { useState } from "react";
import { motion } from "framer-motion";
import * as styles from "./styles/select.module.scss";
import { Country } from "../../../../types/filter-link-card";

type DropdownCountryProps = {
  uniqueCountries?: Country[];
  handleCountryChange: (country: string) => void;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const DropdownCountry: React.FC<DropdownCountryProps> = ({
  uniqueCountries,
  handleCountryChange,
  setIsOpen
}) => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const handleOptionClick = (country: string) => {
    handleCountryChange(country);
    setIsOpen(false);
  };

  const handleMouseEnter = (index: number) => {
    setActiveIndex(index);
  };

  const handleMouseLeave = () => {
    setActiveIndex(-1);
  };

  const handleKeyDown = (event: React.KeyboardEvent, country: string) => {
    if (event.key === "Enter" || event.key === " ") {
      handleOptionClick(country);
    }
  };

  return (
    <motion.ul
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 10 }}
      transition={{ duration: 0.3 }}
      className={`absolute left-0 mt-1 py-1 w-full bg-nexi-colorPalette-coral-99 shadow-neutral-medium rounded-[8px] overflow-hidden z-10 ${styles.noListStyle}`}
    >
      {uniqueCountries?.map((country, index) => (
        <motion.li
          key={country.name}
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          tabIndex={0}
          className={`flex items-center gap-4 m-0 px-4 py-3 text-gray-800 cursor-pointer ${
            index === activeIndex
              ? "bg-nexi-colorPalette-blue-40 border rounded-dropdown mx-1"
              : ""
          } ${
            index === activeIndex
              ? "text-nexi-colorPalette-coral-99"
              : "hover:bg-nexi-colorPalette-blue-40 hover:text-nexi-colorPalette-coral-99 focus:bg-nexi-colorPalette-blue-40"
          }`}
          onClick={() => handleOptionClick(country.name)}
          onKeyDown={(event) => handleKeyDown(event, country.name)}
          onMouseEnter={() => handleMouseEnter(index)}
          onMouseLeave={handleMouseLeave}
          whileTap={{ scale: 0.95 }}
        >
          {country.flag && (
            <img
              src={country.flag}
              alt={`${country.name} flag`}
              className="h-4 w-auto"
            />
          )}
          <span>{country.name}</span>
        </motion.li>
      ))}
    </motion.ul>
  );
};

export default DropdownCountry;
